import { render } from "./CuponesFormPage.vue?vue&type=template&id=776a612a"
import script from "./CuponesFormPage.vue?vue&type=script&lang=js"
export * from "./CuponesFormPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__